<template>
  <div id="app">
    <!-- 全局加载覆盖层 -->
    <LoadingOverlay />

    <!-- Element Plus 语言包由 el-config-provider 动态控制 -->
    <el-config-provider :locale="elementLocale">
      <!-- 登录页面不需要布局 -->
      <template v-if="route.path === '/login'">
        <router-view />
      </template>
      <!-- 其他页面使用布局 -->
      <template v-else>
        <BaseLayout>
          <router-view />
        </BaseLayout>
      </template>
    </el-config-provider>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { ElConfigProvider } from 'element-plus'
import BaseLayout from "./components/BaseLayout.vue";
import LoadingOverlay from "./components/LoadingOverlay.vue";
import i18n from './i18n'
import { LOCALE_CONFIG, DEFAULT_LOCALE } from './utils/locale'

const route = useRoute();

// 响应式地跟随 i18n locale 变化，无需 reload
const elementLocale = computed(() => {
  const current = i18n.global.locale.value
  return LOCALE_CONFIG[current]?.elementPlusLocale || LOCALE_CONFIG[DEFAULT_LOCALE].elementPlusLocale
})
</script>

<style>
:root {
  --primary-color: #FE304C;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  background-color: #f5f5f5;
}

#app {
  width: 100%;
  min-height: 100vh;
}
</style>
